import { useState } from "react";
import {
    Dialog,
    DialogContent,
    Button,
    IconButton,
    Typography,
    AppBar,
    Stack,
    Box,
    MenuItem,
    Select,
    TextField,
    Autocomplete,
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close'
import { CustomTitle, handleSessionOut, Loader } from "../HelperFunctions/HelperFunctions";
import { enqueueSnackbar } from "notistack";
import { UpdateSchedule } from "../API/backend";
import { TimePicker } from 'rsuite';
import "rsuite/dist/rsuite.min.css";
import { useLoaderData } from "react-router-dom";

const UpdateScheduleDialog = ({ open, onClose, reportData, userName, setRefresh }) => {

    const { UID, token } = useLoaderData();

    const [selectedValues, setSelectedValues] = useState(() => ({
        mail_frequency: reportData?.schedule?.mail_frequency ?? "",
        day: reportData?.schedule?.day ?? "",
        time: reportData?.schedule?.time ?? "",
        time_zone: reportData?.schedule?.time_zone ?? "",
    }));

    const [loading, setLoading] = useState(false);

    const handleChange = (heading) => (event) => {
        const value = event.target.value;
        setSelectedValues(prev => ({ ...prev, [heading]: value }));
    };

    const handleSave = async () => {
        setLoading(true)
        // console.log("Sending data:", selectedValues);
        // if (!selectedValues["mailing_frequency"] || !selectedValues["day"] || !selectedValues["time"] || !selectedValues["time_zone"]) {
        if (!selectedValues["mail_frequency"] || !selectedValues["time"] || !selectedValues["time_zone"]) {
            enqueueSnackbar("Please select all fields", { variant: "info" })
            setLoading(false)
            return;
        }
        try {


            const { schedule_id, } = reportData
            const data = {
                user_id: UID,
                schedule_id,
                user_name: userName,
                schedule: selectedValues,
            }
            const reportUpdateSchedule = await UpdateSchedule(data)
            enqueueSnackbar(`${reportUpdateSchedule.message}`, { variant: "success" })
            setRefresh(true)
            onClose()
            setLoading(false)

        } catch (error) {
            if (error.status === 401) {
                await handleSessionOut()
            }
            enqueueSnackbar("Error whiele update schedule", { variant: "error" })
            onClose()
            setLoading(false)
        }
    };

    const generateOptions = () => [
        "End of the Month",
        "---Following Month---",
        ...Array.from({ length: 31 }, (_, i) => `${i + 1}${["st", "nd", "rd"][((i + 1) % 10) - 1] || "th"}`)
    ];

    const dateRanges = (arr, range) => {
        for (let i = 1; i <= range; i++) {
            const suffix = i === 1 ? 'st' : i === 2 ? 'nd' : i === 3 ? 'rd' : 'th';
            arr.push(`${i}${suffix}`);
        }
        return arr;
    }



    const frequencyOptions = [
        {
            heading: "mail_frequency",
            label: ["daily",
                // "weekly", "semi_monthly", "monthly", "quarterly", "half_yearly", "yearly"
            ]
        },
        {
            heading: "day",
            label: generateOptions()
        },
        {
            heading: "time",
            label: ["6:00", "6:30", "7:00", "7:30"]
        },
        {
            heading: "time_zone",
            label: ["EST", "CST", "MST", "IST"]
        }
    ];

    const dayOptions = { //need to take conformation

        weekly: dateRanges(["End of the Week", "---Following Month---"], 7),
        semi_monthly: dateRanges(["End of the Semi Month", "---Following Semi Month---"]),
        monthly: dateRanges(["End of the Semi Month", "---Following Month---"]),
        quarterly: dateRanges(["End of the Quater", "---Following Quater---", "1st", "5th", "10th", "15th"]),


    }

    const handleTimeChange = (time) => {

        // const minutes = time.getMinutes();
        // if (minutes % 10 !== 0) return;

        const formattedTime = time
            ? time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false })
            : "";

        setSelectedValues((prev) => ({
            ...prev,
            time: formattedTime,
        }));
    };


    const formatTime = (timeStr) => {
        if (!timeStr) {
            return null;
        }

        const [hours, minutes] = timeStr.split(':');
        const date = new Date();
        date.setHours(hours);
        date.setMinutes(minutes);
        date.setSeconds(0);
        return date;
    };

    return (
        <Dialog
            open={open}
            sx={{ "& .MuiDialog-paper": { minWidth: "35%", minHeight: "40%", top: 10, position: "fixed" } }}
            PaperProps={{
                elevation: 0,
                sx: { border: "1px solid rgba(0, 0, 0, 0.12)" }
            }}
        >
            <AppBar sx={{ position: 'relative', bgcolor: "#d7d7d7", height: 45 }} elevation={0} >
                <Box sx={{ height: 45, alignContent: "center", padding: "0 8px" }} >
                    <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
                        <Stack direction={"row"}>
                            <IconButton
                                size="small"
                                edge="start"
                                color="inherit"
                                onClick={onClose}
                                aria-label="close"
                                style={{ backgroundColor: "#686868" }}
                                disableRipple
                            >
                                <CloseIcon sx={{ fontSize: "15px" }} />
                            </IconButton>
                            <Typography
                                sx={{
                                    ml: 2,
                                    flexGrow: 10,
                                    color: "#1f1f1f",
                                }}
                                component="div"
                                fontWeight={600}
                                fontSize={"16px"}

                            >
                                Schedule
                            </Typography>
                        </Stack>
                        <Stack direction={"row"} gap={1}>

                            <Button
                                variant="contained"
                                size='small'
                                disableElevation
                                disableRipple

                                sx={{
                                    // px: 3,
                                    textTransform: "none",
                                    backgroundColor: "#b5dcf2",
                                    color: "#000",
                                    fontWeight: 400,
                                }}
                                // onClick={onClose}
                                onClick={handleSave}
                            >
                                Save
                            </Button>
                        </Stack>
                    </Stack>
                </Box>
            </AppBar>

            <DialogContent>
                <Stack p={2} gap={2} width={"450px"}>
                    {frequencyOptions.map((option, index) => {
                        if (option.heading === "day" && selectedValues.mail_frequency === "daily") {
                            if (selectedValues.day !== "") {
                                selectedValues.day = "";
                            }
                            return null;
                        };

                        return (

                            <Stack key={index} direction="row" gap={15} justifyContent="space-between">
                                <Typography sx={{ fontSize: "13px" }}>
                                    {CustomTitle(option.heading)}
                                </Typography>
                                {option.heading === "time" ?
                                    <TimePicker
                                        format="HH:mm"
                                        size="sm"
                                        style={{ width: 170 }}
                                        value={formatTime(selectedValues.time)}
                                        onChange={handleTimeChange}
                                        ranges={[]}
                                        menuStyle={{
                                            zIndex: 1300,
                                            // maxHeight: '280px',
                                            overflow: 'auto'
                                        }}
                                        hideMinutes={(minute) => minute % 10 !== 0}
                                        editable={false}
                                    // closeOnSelect={true}

                                    />
                                    :
                                    // <Select
                                    //     size="small"
                                    //     value={selectedValues[option.heading] || ""}
                                    //     onChange={handleChange(option.heading)}
                                    //     style={{ width: "170px", height: "25px", fontSize: "11px" }}
                                    // >
                                    //     {option.label.map((label, i) => (
                                    //         <MenuItem key={i} value={label}>
                                    //             {CustomTitle(label)}
                                    //         </MenuItem>
                                    //     ))}
                                    // </Select>
                                    <Autocomplete
                                        size="small"
                                        options={option.label}
                                        value={selectedValues[option.heading] || null}
                                        onChange={(event, newValue) =>
                                            handleChange(option.heading)({
                                                target: { name: option.heading, value: newValue }
                                            })
                                        }
                                        getOptionLabel={(label) => CustomTitle(label)}
                                        isOptionEqualToValue={(option, value) => option === value}
                                        disableClearable
                                        disabled={option.heading === "mail_frequency"}
                                        open={option.heading === "mail_frequency" ? false : undefined}

                                        componentsProps={{
                                            paper: {
                                                sx: {
                                                    fontSize: '13px'
                                                }
                                            }
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                name={option.heading}
                                                variant="outlined"
                                                style={{ width: '170px' }}
                                                InputProps={{
                                                    ...params.InputProps,
                                                    style: {
                                                        height: '25px',
                                                        fontSize: '11px',
                                                        padding: '0px 8px'
                                                    }
                                                }}
                                                inputProps={{
                                                    ...params.inputProps,
                                                    readOnly: true,
                                                    style: {
                                                        fontSize: '11px',
                                                        padding: 0,
                                                        height: '25px',
                                                        lineHeight: '25px'
                                                    }
                                                }}
                                            />
                                        )}
                                    />

                                }
                            </Stack>
                        )
                    })}
                </Stack>
            </DialogContent>
            <Loader loading={loading} />
        </Dialog>
    );
};

export default UpdateScheduleDialog;
